import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    SDKAnalytics: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class SdkAnalyticsService {
  private sdkPromise?: Promise<any>;
  private analyticsPromise?: Promise<any>;

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) {}

  private loadSdk(): Promise<any> {
    if (!this.sdkPromise) {
      this.sdkPromise = new Promise((resolve, reject) => {
        const script = this.document.createElement('script');
        script.src = environment.sdkUrl;
        script.async = true;
        script.onload = () => resolve(window.SDKAnalytics);
        script.onerror = reject;
        this.document.head.appendChild(script);
      });
    }

    return this.sdkPromise;
  }


  private async getItauDigitalAnalytics(config: any): Promise<any> {
    if (!this.analyticsPromise) {
      this.analyticsPromise = this.loadSdk().then((SdkAnalytics: any) => {

        return SdkAnalytics(config);
      });
    }

    return this.analyticsPromise;
  }

  async track(configSdk: any, trackData: any): Promise<void> {
    console.log('configDataDog', configSdk)
    console.log('trackDataDog', trackData)
    const ItauDigitalAnalytics = await this.getItauDigitalAnalytics(configSdk);
    ItauDigitalAnalytics.track(trackData);
  }


  reset(): void {
    this.analyticsPromise = undefined;
  }
}
